import { render, staticRenderFns } from "./FavoritesEditor.vue?vue&type=template&id=84452000&scoped=true&"
import script from "./FavoritesEditor.vue?vue&type=script&lang=js&"
export * from "./FavoritesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84452000",
  null
  
)

export default component.exports